const LAST_KNOWN_AUTH_KEY = "auth:lastKnown";

export function getLastKnownAuth() {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(LAST_KNOWN_AUTH_KEY) === "1";
}

export function setLastKnownAuth(value) {
  if (typeof window === "undefined") return;
  localStorage.setItem(LAST_KNOWN_AUTH_KEY, value ? "1" : "0");
}
